import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HotSpringIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HotSpringIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.6716 7.94735L21.6697 7.94672C21.3991 7.87751 21.1229 8.03607 21.0474 8.30348L20.5544 10.1036C19.2397 9.66319 17.4829 9.79722 16.3919 10.4384C15.3597 11.0474 13.4837 11.0462 12.4496 10.4346C11.6927 10.0338 10.8461 9.83056 9.98876 9.8444C9.12077 9.8337 8.27543 10.0332 7.52164 10.4321C6.4048 10.9807 5.10454 11.0411 3.94208 10.6007L3.31319 8.3041C3.27764 8.17322 3.19301 8.06374 3.07535 7.99642C2.95769 7.92847 2.81989 7.91148 2.69059 7.94734C2.56003 7.98258 2.45086 8.06626 2.38322 8.18392C2.31558 8.30158 2.29765 8.43938 2.33351 8.57151L5.14575 18.8414C5.20615 19.061 5.40719 19.2145 5.63527 19.2145H18.7253C18.9531 19.2145 19.1544 19.061 19.2151 18.8414L22.0271 8.57088C22.1007 8.30158 21.9412 8.02159 21.6716 7.94735ZM18.5749 17.3351L18.338 18.1996H6.02288L5.78598 17.3351H18.5749ZM20.2848 11.089L18.8527 16.3196H5.50818L4.26015 11.7622C4.6814 11.8623 5.11178 11.9126 5.54373 11.9126C6.39599 11.9252 7.25392 11.7226 8.01683 11.318C9.04433 10.7108 10.9194 10.7102 11.95 11.318C13.2883 12.1108 15.5541 12.1095 16.8868 11.3243C17.9413 10.8065 19.1705 10.7221 20.2848 11.089Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.30847 8.49601L8.30658 8.49853C8.16186 8.73763 8.23863 9.05097 8.47804 9.19632C8.56047 9.24603 8.65107 9.26994 8.74073 9.26994C8.90621 9.26994 9.06792 9.18877 9.16639 9.03839C9.65528 8.26887 9.62697 7.2936 9.09497 6.55365C8.86688 6.23464 8.80711 5.82314 8.93641 5.44939C9.0223 5.18324 8.87569 4.89632 8.60954 4.80949C8.34999 4.72769 8.07125 4.86046 7.97561 5.12032C7.7406 5.80112 7.85008 6.55806 8.26914 7.14511C8.55889 7.54717 8.57431 8.07758 8.30847 8.49601Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.6579 8.49601L10.656 8.49916C10.5113 8.73826 10.5884 9.05097 10.8278 9.19632C10.9102 9.24603 11.0008 9.26994 11.0902 9.26994C11.2557 9.26994 11.4174 9.18877 11.5159 9.03839C12.0044 8.26887 11.9761 7.2936 11.4444 6.55365C11.2163 6.23464 11.1566 5.82314 11.2859 5.44939C11.3718 5.18261 11.2252 4.89632 10.959 4.80949C10.6988 4.72769 10.4207 4.85983 10.3251 5.12095C10.0901 5.80175 10.1999 6.55806 10.6186 7.14448C10.9084 7.54717 10.9238 8.07758 10.6579 8.49601Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.0074 8.49601L13.0055 8.49916C12.8608 8.73826 12.9379 9.05097 13.1773 9.19632C13.2597 9.24603 13.3503 9.26994 13.44 9.26994C13.6051 9.26994 13.7668 9.18877 13.8653 9.03839C14.3542 8.26887 14.3262 7.2936 13.7942 6.55365C13.5658 6.23464 13.5063 5.82251 13.6356 5.44939C13.7215 5.18324 13.5749 4.89632 13.3085 4.80949C13.0495 4.72769 12.7702 4.86046 12.6748 5.12032C12.4395 5.80175 12.5493 6.55806 12.9684 7.14448C13.2578 7.54717 13.2732 8.07758 13.0074 8.49601Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.3565 8.49538L15.3543 8.49916C15.2102 8.73889 15.2876 9.0516 15.5274 9.19695C15.6092 9.24603 15.6995 9.26931 15.7888 9.26931C15.9543 9.26931 16.116 9.18814 16.2148 9.03839C16.7037 8.26887 16.6754 7.2936 16.1434 6.55365C15.9153 6.23464 15.8555 5.82314 15.9848 5.44939C16.071 5.18324 15.9247 4.89632 15.6579 4.80949C15.3959 4.72769 15.1193 4.86046 15.0243 5.12032C14.789 5.80175 14.8988 6.55806 15.3178 7.14448C15.6076 7.5478 15.6227 8.07758 15.3565 8.49538Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HotSpringIcon;
